function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var IDD = function IDD(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.color || "#222222",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.96 15.81c-2.23 0-2.83-4.88-2.83-7.76s.6-7.76 2.83-7.76 2.83 4.88 2.83 7.76-.6 7.76-2.83 7.76m-.03-14.02c-.33.15-1.3 2.24-1.3 6.26s.92 6 1.33 6.25c.41-.24 1.33-2.32 1.33-6.25s-.97-6.11-1.36-6.26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.21 8.05c0 4.28 3.48 7.76 7.76 7.76s7.76-3.48 7.76-7.76S20.25.29 15.97.29 8.21 3.77 8.21 8.05m2.142-2.76a6.27 6.27 0 0 1 5.618-3.5 6.27 6.27 0 0 1 5.617 3.5zm-.514 1.5h12.264a6.3 6.3 0 0 1 .005 2.5H9.833a6.3 6.3 0 0 1 .005-2.5m6.132 7.52a6.27 6.27 0 0 0 5.627-3.52H10.343a6.27 6.27 0 0 0 5.627 3.52m.03 9.4h.02c.41 0 .82-.15 1.13-.43.37-.33.58-.8.58-1.3v-1.15c0-.81-.55-1.5-1.33-1.7l-2.6-.65c-.69-.17-1.41.08-1.83.65l-1.25 1.67c-4.07-1.84-6.27-4.98-7.44-7.52l1.63-1.24c.55-.42.8-1.13.63-1.81l-.65-2.61c-.2-.78-.9-1.32-1.7-1.32H2c-.5 0-.96.21-1.29.57-.32.35-.47.82-.42 1.29.13 1.2.47 3.07 1.36 5.18l.37.89.02-.02c1.29 2.66 3.62 5.85 7.75 7.82l-.02.02.9.37c1.57.64 3.3 1.07 5.14 1.28.07.01.13.01.19.01m-.03-1.51a18.4 18.4 0 0 1-3.82-.83l1-1.35c.06-.08.16-.11.26-.09l2.6.65c.11.03.19.12.19.24v1.15c0 .1-.05.15-.08.18-.04.05-.09.05-.15.05M1.82 7.86c.04-.04.1-.07.17-.07v-.02h1.19c.11 0 .21.08.24.19l.65 2.61c.02.1-.01.2-.09.26l-1.3 1a17 17 0 0 1-.9-3.854c-.001-.018-.005-.071.04-.116",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0 0h24v24H0z"
  }))));
};
export default IDD;
IDD.displayName = 'IDD';